import React from 'react';

interface PlaceholderImageProps {
  alt: string;
  className?: string;
  type?: 'team' | 'blog' | 'hero';
}

const PlaceholderImage: React.FC<PlaceholderImageProps> = ({ alt, className = '', type = 'blog' }) => {
  const getGradient = () => {
    switch (type) {
      case 'team':
        return 'bg-gradient-to-br from-primary-400 to-primary-600';
      case 'hero':
        return 'bg-gradient-to-br from-primary-500 to-secondary-600';
      default:
        return 'bg-gradient-to-br from-secondary-400 to-primary-500';
    }
  };

  return (
    <div 
      className={`${getGradient()} flex items-center justify-center text-white font-semibold ${className}`}
      role="img"
      aria-label={alt}
    >
      <div className="text-center">
        <div className="text-2xl mb-2">📸</div>
        <div className="text-sm opacity-90">{alt}</div>
      </div>
    </div>
  );
};

export default PlaceholderImage;

